// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"585":"74c2366aaea1c9f76a0d","665":"c058b6d870606c5abca6"}[chunkId] + ".js";
};